import FIELD_TYPE from 'Component/Field/Field.config';
import { VALIDATION_INPUT_TYPE } from 'Util/Validator/Config';

/**
 * Returns fields for share wishlist form
 * @returns {Object}
 * @namespace Pwa/Component/ShareWishlistForm/Form/shareWishlistForm */
export const shareWishlistForm = () => [
    {
        type: FIELD_TYPE.email,
        label: __('Email addresses, separated by commas'),
        attr: {
            name: 'emails',
            placeholder: __('Enter e-mail addresses...'),
            'aria-label': __('Email address'),
        },
        validateOn: ['onChange'],
        validationRule: {
            inputType: VALIDATION_INPUT_TYPE.emailList,
            isRequired: true,
        },
        addRequiredTag: true,
    },
    {
        label: __('Message'),
        type: FIELD_TYPE.textarea,
        attr: {
            name: 'message',
            placeholder: __('Enter message...'),
            'aria-label': __('Message'),
        },
    },
];

export default shareWishlistForm;
